import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { Box, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { Badge, Icon } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import { BIGGER_ROOM_CODE, NEW_HOTEL_MESSAGING_FLAG_TEXT, NEW_ROOMS_MESSAGING_FLAG_TEXT, OPENING_SOON_MESSAGING_FLAG_TEXT, PREMIER_EXTRA_CODE, PREMIER_PLUS_FACILITY_CODE, STANDARD_EXTRA_FACILITY_CODE } from '../../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('@whitbread-eos/atoms'),
    Tooltip = _yield$import.Tooltip;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
export default function HotelBadges(_ref2) {
  var _hotelFlags$flagBanne, _hotelFlags$flagBanne2, _hotelFlags$flagBanne3, _hotelFlags$flagBanne4, _hotelFlags$flagBanne5, _hotelFlags$flagBanne6;
  var hubBadge = _ref2.hubBadge;
  var _useStaticHotelInform = useStaticHotelInformation(),
    brand = _useStaticHotelInform.brand,
    hotelFacilities = _useStaticHotelInform.hotelFacilities,
    messagingFlag = _useStaticHotelInform.messagingFlag,
    hotelFlags = _useStaticHotelInform.hotelFlags,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var badges = facility => PREMIER_PLUS_FACILITY_CODE === facility.code || STANDARD_EXTRA_FACILITY_CODE === facility.code;
  var visibleBadges = item => item.isVisible;
  var displayedBadges = useMemo(() => (hotelFacilities || []).filter(badges).filter(visibleBadges), [hotelFacilities]);
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  var isFlagBannerVisible = !!(hotelFlags !== null && hotelFlags !== void 0 && hotelFlags.isEnabled && hotelFlags !== null && hotelFlags !== void 0 && hotelFlags.flagBanner);
  if (!displayedBadges.length && !(messagingFlag !== null && messagingFlag !== void 0 && messagingFlag.text) && !hubBadge && !isFlagBannerVisible) {
    return null;
  }
  return _jsxs(Wrap, {
    "data-testid": "hdp_badgesList",
    align: "center",
    children: [(brand === null || brand === void 0 ? void 0 : brand.toLowerCase()) === 'hub' && !!hubBadge && _jsx(WrapItem, {
      children: _jsx(Icon, {
        src: formatAssetsUrl(hubBadge)
      })
    }), isFlagBannerVisible && _jsx(WrapItem, {
      children: _jsxs(Badge, {
        variant: "primary",
        badgecolor: (_hotelFlags$flagBanne = hotelFlags === null || hotelFlags === void 0 || (_hotelFlags$flagBanne2 = hotelFlags.flagBanner) === null || _hotelFlags$flagBanne2 === void 0 ? void 0 : _hotelFlags$flagBanne2.backgroundColour) !== null && _hotelFlags$flagBanne !== void 0 ? _hotelFlags$flagBanne : undefined,
        color: (_hotelFlags$flagBanne3 = hotelFlags === null || hotelFlags === void 0 || (_hotelFlags$flagBanne4 = hotelFlags.flagBanner) === null || _hotelFlags$flagBanne4 === void 0 ? void 0 : _hotelFlags$flagBanne4.textColour) !== null && _hotelFlags$flagBanne3 !== void 0 ? _hotelFlags$flagBanne3 : undefined,
        display: "flex",
        alignItems: "center",
        gap: "xs",
        children: [(hotelFlags === null || hotelFlags === void 0 || (_hotelFlags$flagBanne5 = hotelFlags.flagBanner) === null || _hotelFlags$flagBanne5 === void 0 ? void 0 : _hotelFlags$flagBanne5.backgroundImage) && _jsx(Icon, {
          src: formatAssetsUrl(hotelFlags.flagBanner.backgroundImage)
        }), _jsx(Text, {
          as: "span",
          textStyle: "label-m",
          children: hotelFlags === null || hotelFlags === void 0 || (_hotelFlags$flagBanne6 = hotelFlags.flagBanner) === null || _hotelFlags$flagBanne6 === void 0 ? void 0 : _hotelFlags$flagBanne6.text
        })]
      })
    }), displayedBadges.map(badge => {
      var _badge$name, _badge$code, _badge$name2;
      return badge.code === PREMIER_PLUS_FACILITY_CODE ? _jsx(WrapItem, {
        children: _jsx(Tooltip, {
          description: t('hoteldetails.title.badge.ultimate.tooltip'),
          variant: "facilities",
          placement: "bottom-start",
          closeOnClick: false,
          ml: "2rem",
          colorScheme: getColor(badge.code),
          children: renderHotelBadge(badge.code, (_badge$name = badge.name) !== null && _badge$name !== void 0 ? _badge$name : '')
        })
      }, badge.name) : _jsx(WrapItem, {
        children: renderHotelBadge((_badge$code = badge.code) !== null && _badge$code !== void 0 ? _badge$code : '', (_badge$name2 = badge.name) !== null && _badge$name2 !== void 0 ? _badge$name2 : '')
      }, badge.name);
    }), (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) && (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) !== 'hub' && _jsx(WrapItem, {
      children: renderHotelBadge(NEW_HOTEL_MESSAGING_FLAG_TEXT, messagingFlag.text)
    })]
  });
  function renderHotelBadge(badgeColor, badgeText) {
    return _jsx(Box, {
      children: _jsx(Badge, {
        variant: "primary",
        badgecolor: getColor(badgeColor),
        cursor: "pointer",
        children: badgeText
      })
    });
  }
}
export function getColor(label) {
  switch (label) {
    case BIGGER_ROOM_CODE:
      return 'lightPurple';
    case PREMIER_PLUS_FACILITY_CODE:
      return 'primary';
    case NEW_HOTEL_MESSAGING_FLAG_TEXT:
    case NEW_ROOMS_MESSAGING_FLAG_TEXT:
    case OPENING_SOON_MESSAGING_FLAG_TEXT:
      return 'maroon';
    case PREMIER_EXTRA_CODE:
      return 'blue';
    default:
      return 'darkPink';
  }
}